import { render } from "./sidemenu.vue?vue&type=template&id=b13f0c9c&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"

import "./sidemenu.vue?vue&type=style&index=0&id=b13f0c9c&scoped=true&lang=css"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13f0c9c"]])

export default __exports__